import styled, { css } from 'styled-components';
import { Atom } from 'AppReact';

export const template = styled.div`
  ${({ theme, displayState }) => css`
    display: ${displayState.hidden ? 'none' : ''};
    margin-left: 3px;
    margin-right: 3px;
    font-size: 12px;
    font-weight: 400;
    cursor: pointer;

    color: #334D6E;
    ${displayState.selected && css`
      color: ${theme?.colour?.primary ?? '#1DBD6B'};
    `}
  `}
`;

export default Atom({ type: 'button', dataType: 'number', template });
